import ApiService from "../api";

export default class ContaContabilService extends ApiService {

    constructor() {
        super("/api/conta-contabil");
    }

    listar() {
        return this.get("");
    }

    listarPorPrefixo(prefixoCodigo) {
        return this.get(`?prefixoCodigo=${encodeURIComponent(prefixoCodigo)}`);
    }

    buscarPorCodigo(codigo) {
        return this.get(`/${codigo}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(codigo, dto) {
        return this.put(`/${codigo}`, dto);
    }

    excluir(codigo) {
        return this.delete(`/${codigo}`);
    }

    sincronizar() {
        return this.put(`/sincronizar-fortes`);
    }
}
